import React from "react";
import PropertyInventoryPage from "./propertyInventory.jsx";

function Summer() {
  return <PropertyInventoryPage propertyId="Summer" />;
}

export default Summer;
